<template>
  <div class="modal fade" id="subscribeModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <button type="button" class="btn-close d-none" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="text-center mb-4">
            <div class="avatar-md mx-auto mb-4">
              <div class="avatar-title bg-light rounded-circle text-primary h1">
                <i class="mdi mdi-card-account-phone-outline"></i>
              </div>
            </div>

            <div v-if="message !== null" class="alert alert-danger" role="alert">
              {{ message }}
            </div>

            <div class="row justify-content-center">
              <div class="col-xl-10">
                <h4 class="text-primary">Client's Phone No.</h4>
                <p class="text-muted font-size-14 mb-4">
                  Enter the client's Phone Number to continue.
                </p>

                <form>
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3">
                        <label for="digit1-input" class="visually-hidden">Phone Number</label>
                        <input
                            v-model="localPhoneNumber"
                            type="text"
                            class="form-control form-control-lg text-center two-step"
                            placeholder="Enter Client Phone Number"
                        >
                      </div>
                    </div>
                  </div>

                  <button @click.prevent="handleSearch" type="button" class="btn btn-primary btn-block w-100">
                    <i class="bx bx-search-alt-2 font-size-16 align-middle me-2"></i>
                    Search
                  </button>

                  <button
                      data-toggle="modal"
                      data-target="#registerCustomer"
                      data-dismiss="modal"
                      type="button"
                      class="btn btn-light btn-block w-100 mt-3"
                  >
                    Register User
                  </button>

                  <button
                      style="display: none"
                      data-toggle="modal"
                      data-dismiss="modal"
                      type="button"
                      id="closeModalSearch"
                  >
                    close
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerSearchModal',

  props: {
    phoneNumber: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      localPhoneNumber: this.phoneNumber
    }
  },

  watch: {
    phoneNumber(newVal) {
      this.localPhoneNumber = newVal
    },
    localPhoneNumber(newVal) {
      this.$emit('update:phoneNumber', newVal)
    }
  },

  methods: {
    handleSearch() {
      this.$emit('search-customer', this.localPhoneNumber)
    }
  }
}
</script>